"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataBox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Layout = require("../../../DataDisplay/Layout");
/**
 * データ表示用コンポーネント
 *
 * @param main { title: タイトルテキスト, value: 値 string }
 * @param subs Array<{ title: タイトルテキスト, value: 値 string }>
 */
var DataBox = function (_a) {
    var main = _a.main, _b = _a.subs, subs = _b === void 0 ? [] : _b;
    return ((0, jsx_runtime_1.jsxs)(Layout.Container, { sx: { bgcolor: 'background.paper', borderRadius: 3 }, children: [!!main && ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { xs: 'flex-start', md: 'center' },
                    justifyContent: 'space-between',
                    mb: { xs: 4, md: 3 },
                }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h3", sx: { mb: { xs: 3, md: 0 } }, children: main === null || main === void 0 ? void 0 : main.title }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h2", children: main === null || main === void 0 ? void 0 : main.value })] })), (subs === null || subs === void 0 ? void 0 : subs.length) > 0 &&
                subs.map(function (_a) {
                    var title = _a.title, value = _a.value;
                    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
                            display: 'flex',
                            flexDirection: { xs: 'column', md: 'row' },
                            alignItems: { xs: 'flex-start', md: 'center' },
                            justifyContent: 'space-between',
                            mb: { xs: 3, md: 0 },
                        }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", children: title }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle1", children: value })] }));
                })] }));
};
exports.DataBox = DataBox;
